const cabinetsData = [
  {
    id: 1,
    item: "SW-BT9",
    description: 'Shaker White Tray Base Cabinet - 9"W x 34-1/2"H x 24"D -1D',
    price: 709.0,
    image: "/cabinet-item-images/Framed-BT9.png",
  },
  {
    id: 2,
    item: "SW-B12FH",
    description:
      'Shaker White Full Height Door Base Cabinet - 12"W x 34-1/2"H x 24"D -1D-1S',
    price: 943.0,
    image: "/cabinet-item-images/Framed-B[12-21]FH.png",
  },
  {
    id: 3,
    item: "SW-B24FH",
    description:
      'Shaker White Full Height Door Base Cabinet - 24"W x 34-1/2"H x 24"D -2D-1S',
    price: 846.0,
    image: "/cabinet-item-images/Framed-B[24-36]FH.png",
  },
  {
    id: 4,
    item: "SW-W1530",
    description: 'Shaker White Wall Cabinet - 15"W x 30"H x 12"D -1D-2S',
    price: 23.0,
    image: "/cabinet-item-images/Framed-W[09-21]30.png",
  },
  {
    id: 5,
    item: "CS-BT9",
    description:
      'Casselberry Saddle Tray Base Cabinet - 9"W x 34-1/2"H x 24"D -1D',
    price: 217.0,
    image: "/cabinet-item-images/Framed-BT9.png",
  },
  {
    id: 6,
    item: "CS-LACM8",
    description:
      'Casselberry Saddle Large Angle Crown Moulding - 96"W x 3"H x 3"D',
    price: 401.0,
    image: "/cabinet-item-images/Framed-LACM8.png",
  },
  {
    id: 7,
    item: "CS-F342",
    description: 'Casselberry Saddle 3"W Filler - 3"W x 42"H x 3/4"D',
    price: 264.0,
    image: "/cabinet-item-images/F342.png",
  },
  {
    id: 8,
    item: "CS-W1530",
    description: 'Casselberry Saddle Wall Cabinet - 15"W x 30"H x 12"D -1D-2S',
    price: 705.0,
    image: "/cabinet-item-images/Framed-W[09-21]30.png",
  },
  {
    id: 9,
    item: "VMN-B24FH",
    description:
      'Verona Midnight Navy Full Height Door Base Cabinet - 24"W x 34-1/2"H x 24"D -2FHD-1S',
    price: 719.0,
    image: "/cabinet-item-images/Framed-B[24-36]FH.png",
  },
  {
    id: 10,
    item: "VMN-W1830",
    description:
      'Verona Midnight Navy One Door Wall Cabinet - 18"W x 30-1/4"H x 13-1/2"D -1D-2S',
    price: 35.0,
    image: "/cabinet-item-images/Framed-W[09-21]30.png",
  },
  {
    id: 11,
    item: "VMN-VB12FH",
    description:
      'Verona Midnight Navy Full Height One Door Vanity Base Cabinet - 12"W x 34-1/2"H x 21"D -1FHD-1',
    price: 397.0,
    image: "/cabinet-item-images/Frameless-VB[12-18]FH.png",
  },
  {
    id: 12,
    item: "VMN-BM8",
    description: 'Verona Midnight Navy Batten Moulding - 96"W x 1/4"H x 3/4"D',
    price: 279.0,
    image: "/cabinet-item-images/BM8.png",
  },
  {
    id: 13,
    item: "TDW-BPO6FH",
    description:
      'Torino Dark Wood Base Cabinet with Basket Pullout - 6"W x 34-1/2"H x 24"D -1FHD',
    price: 211.0,
    image: "/cabinet-item-images/Frameless-BPO6.png",
  },
  {
    id: 14,
    item: "TDW-TB2472SFH",
    description:
      'Torino Dark Wood Tall Two Door Utility with Shelves - 24"W x 71-1/4"H x 24"D -2D-4S',
    price: 294.0,
    image: "/cabinet-item-images/Frameless-TB[12-24S]72FH.png",
  },
  {
    id: 15,
    item: "TDW-W3623",
    description:
      'Torino Dark Wood 13-1/2"D Two Door Wall Stacker Cabinet - 36"W x 22-5/8"H x 13-1/2"D -2D-1S',
    price: 748.0,
    image: "/cabinet-item-images/Frameless-W[24-36]23.png",
  },
  {
    id: 16,
    item: "TDW-TKC",
    description: 'Torino Dark Wood Toe Kick Cover - 96"W x 4-1/2"H x 5/8"D',
    price: 249.0,
    image: "/cabinet-item-images/TKC.png",
  },
];

export { cabinetsData } ;
